<template>
    <div class="video-tour-container">
        <template v-if="!media">
            <p class="text-primary">{{ $t('components.video_tour.upload_video')}}</p>

            <button class="button button-m button-primary mb-40" @click.prevent="embedVideo()">{{ $t('components.video_tour.embed_video') }}</button>
        </template>
        <template v-else>
            <template v-if="media.type == 'embedded_video'">
                <p>{{ $t('components.video_tour.upload_video') }}</p>

                <div class="video-tour-inner-container mb-48">
                    <div class="video-tour-container__iframe-wrap">
                        <iframe :src="media.data.url"></iframe>
                    </div>
                    <div class="video-tour-container__bottom">
                        <p class="text-secondary">{{ media.data.original_url }}</p>

                        <button class="button button-remove" @click.prevent="removeEmbeddedVideo()"><img src="/img/bin.svg" alt="">{{ $t('common.remove') }}</button>
                    </div>
                </div>
                
            </template>
        </template>
    </div>
</template>

<script>
    export default {
        props: {
            media: {
                default: null,
                type: Object
            },
            listing_id: {
                default: null,
                type: Number
            }

        },
        data() {
            return {
                
            }
        },
        methods: {
            embedVideo() {
                this.$root.$emit('show_add_video', 'video_tour', '', true);
            },
            removeEmbeddedVideo() {
                let url =  `/api/media/remove/${this.listing_id}`;

                axios.post(url, {column: 'video_tour'}).then(function (response) {
                    console.log('deleted');
                }).then(function(response) {
                    this.$root.$emit('video_removed', 'video_tour');
                }.bind(this));
            }
        },
        watch: {
        }
    }
</script>
